import React from 'react';
import SelectInput from '../misc/SelectInput.js';

class VideoVitalsFilterForm extends React.Component {
  state = {
    sport: this.props.initialFilters.sport,
    position: this.props.initialFilters.position,
  };

  _positionChanged = (event) => {
    if (event.target.value) {
      this.setState({position: parseInt(event.target.value, 10)});
    } else {
      this.setState({position: undefined});
    }
  };

  _sportChanged = (event) => {
    if (event.target.value) {
      this.setState({sport: parseInt(event.target.value, 10), position: undefined});
    } else {
      this.setState({sport: undefined, position: undefined});
    }
  };

  render() {
    let gradYearOptions = this.props.allGradYears.map((year, idx) => {
      let defaultChecked = this.props.initialFilters.grad_years.indexOf(year) >= 0;
      return (
        <div key={idx} className="col-xs-3">
          <div className="checkbox">
            <label>
              <input type="checkbox" name="grad_years[]" value={year} defaultChecked={defaultChecked} />
              {year}
            </label>
          </div>
        </div>
      );
    });

    let sportOptions = this.props.allSports.map((sport, idx) => {
      return (
        <option key={sport.id} value={sport.id}>{sport.name}</option>
      );
    });

    let positionOptions = null;
    if (this.state.sport) {
      let possiblePositions = this.props.allPositions.filter(p => p.sport_id === this.state.sport);
      positionOptions = possiblePositions.map((p, idx) => {
        return (
          <option key={p.id} value={p.id}>{p.name}</option>
        );
      });
    }
    return (
      <form className="form-horizontal" action={this.props.actionUrl}>
        <div className="form-group">
          <label className="col-sm-3 control-label">
            Graduation Year
          </label>
          <div className="col-sm-6">
            <div className="row">
              {gradYearOptions}
            </div>
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-3 control-label">
            Sport
          </label>
          <div className="col-sm-3">
            <SelectInput className="form-control" name="sport" value={this.state.sport} onChange={this._sportChanged}>
              <option value="">Any Sport</option>
              {sportOptions}
            </SelectInput>
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-3 control-label">
            Position
          </label>
          <div className="col-sm-3">
            <SelectInput className="form-control" name="position" disabled={!this.state.sport} value={this.state.position} onChange={this._positionChanged}>
              <option value="">Any Position</option>
              {positionOptions}
            </SelectInput>
          </div>
        </div>
        <div className="form-group">
          <div className="col-sm-offset-3 col-sm-6 txt-right">
            <input type="submit" className="btn btn-primary" defaultValue="Filter" />
          </div>
        </div>
      </form>

    );
  }
}

export default VideoVitalsFilterForm;
